import { $localStorage, $rootScope, $http, $q } from "ng";
import $appConfig from "servicestack/config";
import config from "webfonts/webfonts.config";
import WebFont from "webfontloader";
import _ from "underscore";

var webfonts = {
  defaultText: "Ag",
  $load: WebFont.load,
  load(fam, txt) {
    var args = {
      slug: webfonts.normalize(fam),
      fam,
      txt,
      font: webfonts.index[webfonts.normalize(fam)],
    };
    var deferred = $q.defer();
    if (!webfonts.fontQuery) {
      webfonts.fontQuery = webfonts.getFonts();
    }

    webfonts.fontQuery.then(() => {
      if (!args.font) {
        return deferred.reject(args);
      }

      if (args.font.status) {
        return deferred.resolve(args);
      }
      args.font.status = "loading";

      let req = {
        classes: false,
        fontloading() {
          $rootScope.$emit("webfontLoading", args, arguments);
          return deferred.notify(args);
        },
        fontactive() {
          args.font.status = "loaded";
          $rootScope.$emit("webfontLoaded", args, arguments);
          return deferred.resolve(args);
        },
        fontinactive() {
          console.warn("webfont.fontinactive", args, arguments);
          $rootScope.$emit("webfontError", args, arguments);
          return deferred.reject(args);
        },
      };

      if (args.font.kind == "webfonts#webfont") {
        req.google = {
          families: [args.font.family],
        };
      } else {
        req.custom = {
          families: [args.font.family, args.font.slug],
          //urls: [`data:text/css,@font-face {font-family: '${args.font.family}'; src: url('${args.font.files.regular}');}`]
          urls: [
            `${$appConfig.serviceUrl}WebFont?FontFamily=${encodeURIComponent(
              args.font.family
            )}&Url=${encodeURIComponent(
              args.font.files.regular
                .replace("ttf", "woff")
                .replace("otf", "woff")
            )}`,
          ],
        };
      }

      WebFont.load(req);
    });
    return deferred.promise;
  },
  results: [],
  categories: [],
  map: {},
  index: {},
  recent: $localStorage.recentFonts,
  addRecent(fam) {
    webfonts.recent = $localStorage.recentFonts = _.chain(
      [fam].concat($localStorage.recentFonts)
    )
      .uniq()
      .take(50)
      .value();
  },
  clearRecent() {
    webfonts.recent = $localStorage.recentFonts = [];
  },
  normalize: (fam) =>
    angular.isString(fam)
      ? fam
          .replace(/\-(regular|italic|bold)/gi, "")
          .replace(/[^a-zA-Z]/gi, "")
          .toLowerCase()
      : angular.isObject(fam)
      ? fam.family || ""
      : "",
  getFonts: () =>
    $http.get(config.url).then((res) => {
      webfonts.results = res.data.items
        .filter(
          (f) =>
            config.forbiddenFonts.indexOf(f.family) === -1 &&
            f.subsets.indexOf("latin") >= 0
        )
        .map((f) => {
          return {
            loadedStrings: {},
            slug: webfonts.normalize(f.family),
            kind: f.kind,
            family: f.family,
            category: f.category,
            files: f.files,
            variants: f.variants,
          };
        });
      webfonts.categories = _.groupBy(webfonts.results, "category");
      webfonts.map = _.indexBy(webfonts.results, "family");
      webfonts.index = _.indexBy(webfonts.results, "slug");

      return webfonts;
    }),
  pager: {
    itemsPerPage: 6,
    pageSizes: [4, 5, 6, 7, 8, 10, 12, 15],
    currentPage: 1,
    maxSize: 1,
    getSkip() {
      return webfonts.pager.itemsPerPage * (webfonts.pager.currentPage - 1);
    },
    pageInfo() {
      var begin =
        (webfonts.pager.currentPage - 1) * webfonts.pager.itemsPerPage;
      var end = begin + webfonts.pager.itemsPerPage;
      return (
        webfonts.results.length &&
        "Showing " +
          (begin + 1) +
          " - " +
          Math.min(end, webfonts.results.length) +
          " of " +
          webfonts.results.length
      );
    },
  },
};

export default webfonts;
